import z from 'zod';

export const languageCodeSchema = z.enum([
	'en',
	'fr',
	'de',
	'nl',
	'pl',
	'bg',
	'cs',
	'da',
	'es',
	'fi',
	'hr',
	'hu',
	'it',
	'no',
	'pt',
	'ro',
	'ru',
	'sk',
	'si',
	'sv',
	'tr',
	'uk',
]);

export const languageSchema = z
	.object({
		code: languageCodeSchema,
		name: z.string(),
		nativeName: z.string(),
	})
	.describe('Language');

export const languagesSchema = z.array(languageSchema).describe('Languages');
